import apiClient from "./apiClient";

export const getAllServices = async (page, per_page) => {
  try {
    const response = await apiClient.get(
      `/admin/services?page=${page}&per_page=${per_page}`,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getServiceById = async (id) => {
  try {
    const response = await apiClient.get(`/admin/services/${id}`, {
      headers: {
        organization_id: 1,
        website_id: 1,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createService = async (payload) => {
  try {
    const response = await apiClient.post("/admin/services", payload, {
      headers: {
        organization_id: 1,
        website_id: 1,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateService = async (id, payload) => {
  try {
    const response = await apiClient.put(`/admin/services/${id}`, payload, {
      headers: {
        organization_id: 1,
        website_id: 1,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteService = async (id) => {
  try {
    const response = await apiClient.delete(`/admin/services/${id}`, {
      headers: {
        organization_id: 1,
        website_id: 1,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addServiceStorageItem = async (payload, service_id) => {
  try {
    const response = await apiClient.post(
      "admin/services/storage_items",
      payload,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
          service_id: service_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateServiceStorageItem = async (id, payload) => {
  console.log(id, "iddddd");

  try {
    const response = await apiClient.put(`admin/services/${id}`, payload, {
      headers: {
        organization_id: 1,
        website_id: 1,
        service_id: id,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteServiceStorageItem = async (id, service_id) => {
  try {
    const response = await apiClient.delete(
      `admin/services/storage_items/${id}`,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
          service_id: service_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generatePresignedUrl = async (data) => {
  try {
    const response = await apiClient.post("admin/generate_presigned_url", {
      file_name: data,
    });
    console.log(response);

    // return await response.json();
    return response.data;
  } catch (error) {
    console.error("Error generating presigned URL:", error);
    throw error;
  }
};
